import * as React from 'react';
import InterviewPracticePage from '@components/pass/interview';
import Header from '@common/header';
import Layout from '@common/layout';
import Footer from '@common/footer';
import { PassInterviewCustomHead } from '@common/customHead';

const PassInterviewPage: React.FC = () => {
  return (
    <Layout>
      <PassInterviewCustomHead />
      <Header />
      <InterviewPracticePage />
      <Footer />
    </Layout>
  );
};

export default PassInterviewPage;
